module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/woman-mobile@2x_d81658.png";